import { APP_CONSTANTS } from "../../core/config/appConstants";
import Container from "../../shared/components/Container/Container";
import useTitle from "../../core/hooks/useTitle";

const DeniedByUser = ({ email }) => {
	useTitle("Bestätigung abgelehnt");

	const buttons = [
		{
			label: "Zu Telekom.de",
			variant: "primary",
			onClick: () =>
				(window.location.href =
					APP_CONSTANTS.LINK.TELEKOM),
			size: "small",
			tabIndex: 1,
			ariaLabel: "Link zu Telekom.de"
		}
	];
	const icons = [
		{
			name: "success-type-standard",
			size: 64,
			color: "var(--color-success)"
		}
	];

	return (
		<Container
			title="Bestätigung abgelehnt"
			description={`Sie haben die Bestätigung der E-Mail-Adresse ${email} abgelehnt.`}
			buttons={buttons}
			icon={icons[0]}
		></Container>
	);
};

export default DeniedByUser;
